import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer } from "components/common";
//#endregion
import { useArticleService } from "serviceHooks";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const ArticlesSalesSummaryOverTimeLine: React.FC = () => {
  const labelFormatter = (label?: string) => {
    return label ? label.substring(0, 3) : "";
  };
  const articleService = useArticleService();
  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Line}
      chartAPIKey={GraphConstants.ChartKeys.ArticlesSalesSummaryOverTimeLine}
      labelFormatter={labelFormatter}
      filterToAPIHandler={articleService.reportToAPIFilter}
      usePageFilter
      yAxisTickUnit={ChartEnums.YAxisTickUnitType.Currency}
    />
  );
};

export default ArticlesSalesSummaryOverTimeLine;
